import { vaultGetRequest } from '../helpers';
import type { IFetchCropQueueResponse } from './fetch-crop-queue-response';
import { fetchCropQueueResponseSchema } from './fetch-crop-queue-response';

export async function fetchCropQueueApi(): Promise<IFetchCropQueueResponse> {
  return vaultGetRequest({ path: '/crop/queue', schema: fetchCropQueueResponseSchema });
}
